<template>
  <div
    class="search-set"
    style="width: 100%; overflow-y: auto"
  >
    <div style="margin: 6px 6px 0 6px">
      <input
        class="ag-input-field-input ag-text-field-input"
        type="text"
        v-model="filterText"
        v-on:keyup="updateVisibleGroups()"
        v-on:keyup.enter="filterOnFirstResult()"
        placeholder="Search..."
      />
    </div>
    <div
      v-if="visibleGroups.length > 0"
      id="search-set-select-all"
      @click="toggleAllFilterGroups()"
      style="align-items: center; height: 100%; line-height: normal; font-size: 14px"
      :class="{
        isChecked: selectAll,
      }"
    >
      <input
        style="margin: 6px; cursor: pointer"
        type="checkbox"
        :checked="selectAll"
        :disabled="selectAll"
        :indeterminate.prop="indeterminate"
      />
      <label style="cursor: pointer"> (Select All) </label>
      <hr style="margin: 0px; height: 1px; border-width: 0; color: lightgray; background-color: lightgray" />
    </div>
    <template v-if="visibleGroups.length > 0">
      <template v-for="value in visibleGroups">
        <div
          class="search-set-filter-checkbox"
          :key="value.name"
          @click="
            e => {
              onClickIndividualFilter(value.name)
            }
          "
        >
          <input
            style="margin: 6px; cursor: pointer"
            type="checkbox"
            :checked="value.checked"
            :input="value.checked"
          />
          <label style="cursor: pointer">
            {{ value.name }}
          </label>
        </div>
      </template>
    </template>
    <div
      style="margin: 6px"
      v-if="visibleGroups.length === 0"
    >
      <label>No Results Found</label>
    </div>
  </div>
</template>

<script>
  import Vue from 'vue'

  const FILTER_STATES = {
    init: 0,
    changed: 1,
    reset: 2,
  }
  export default Vue.extend({
    data() {
      return {
        filterText: '',
        selectAll: true,
        indeterminate: false,
        groups: [],
        model: {},
        values: [],
      }
    },
    mounted() {
      this.groups = this.params.values
      this.values = this.params.values
    },
    methods: {
      onClickIndividualFilter(name) {
        let selected = this.groups.filter(x => x.name === name)[0]
        selected.checked = !selected.checked
        if (Array.isArray(selected.value)) {
          let selectedGroup = selected.value
          this.groups.forEach(el => {
            if (selectedGroup.includes(el.value)) {
              el.checked = selected.checked
            }
          })
        } else {
          // check the other group filter options to see if current checked filter options are contained in them
          const checkedVals = new Set([...this.model.values])
          if (selected.checked) checkedVals.add(selected.value)
          else checkedVals.delete(selected.value)

          this.groups.forEach(el => {
            if (!Array.isArray(el.value)) return
            // check group option if values are a subset of all checked values
            el.checked = el.value.every(val => checkedVals.has(val))
          })
        }
        this.updateGroupFilters()
      },
      toggleAllFilterGroups() {
        this.selectAll = !this.selectAll

        this.groups.forEach(group => {
          group.checked = this.selectAll
        })
        this.updateGroupFilters()
      },
      clearSearchFilter() {
        this.groups.forEach(group => {
          group.visible = true

          if (group.name === 'Canoe Linear') {
            group.visible = process.env.ENABLE_CANOE_LINEAR
          }

          if (group.name === 'Canoe VOD') {
            group.visible = process.env.ENABLE_CANOE_VOD
          }
        })
      },
      updateGroupFilters() {
        this.clearSearchFilter()
        this.updateSelectAllState()
        this.params.filterChangedCallback()
      },
      updateSelectAllState() {
        if (this.visibleGroups.length === this.values.length && this.activeGroups.length === this.values.length) {
          this.selectAll = true
          this.indeterminate = false
        } else {
          if (this.visibleGroups.length === 0 || this.activeGroups.length === 0) {
            this.selectAll = false
            this.indeterminate = false
          } else if (this.activeGroups.length === this.values.length) {
            this.selectAll = true
            this.indeterminate = false
          } else {
            this.selectAll = false
            this.indeterminate = true
          }
        }
      },
      updateVisibleGroups() {
        const searchWords = this.filterText
          .toLowerCase()
          .split(' ')
          .filter(word => word)

        if (searchWords.length === 0) {
          this.clearSearchFilter()
        } else {
          this.groups.forEach(group => {
            searchWords.forEach(filterWord => {
              const value = group.name

              if (value.toString().toLowerCase().indexOf(filterWord) < 0) {
                group.visible = false
              } else {
                group.visible = true

                if (group.name === 'Canoe Linear') {
                  group.visible = process.env.ENABLE_CANOE_LINEAR
                }

                if (group.name === 'Canoe VOD') {
                  group.visible = process.env.ENABLE_CANOE_VOD
                }
              }
            })
          })
        }

        this.updateSelectAllState()
      },
      filterOnFirstResult() {
        if (this.visibleGroups.length === 0) return

        const firstGroup = this.visibleGroups[0]

        const index = this.groups.findIndex(group => group.name === firstGroup.name)

        this.groups.forEach(function (group, i) {
          if (i === index) {
            group.checked = true
          } else {
            group.checked = false
          }
        })

        this.updateGroupFilters()
        this.filterText = ''
      },
      isFilterActive() {
        let active = this.model && this.model.values && this.model.values.length > 0
        return active
      },
      getModel() {
        if (this.selectAll) {
          return null
        }
        const models = []

        this.visibleGroups.forEach(group => {
          if (group.checked) {
            if (group.value instanceof Array) {
              group.value.forEach(value => {
                if (models.indexOf(value) < 0) {
                  models.push(value)
                }
              })
            } else {
              if (models.indexOf(group.value) < 0) {
                models.push(group.value)
              }
            }
          }
        })

        this.model = {
          filterType: 'set',
          values: models,
        }
        return this.model
      },
      updateFilterValues(values) {
        this.groups = this.model = this.values = values
      },
      setModel(model) {
        // This setter is only used when resetting all of the grid's filters
        // When a filter reset is done each filter's model is set to null
        this.groups.forEach(group => {
          group.visible = true
          if (group.name === 'Canoe Linear') {
            group.visible = process.env.ENABLE_CANOE_LINEAR
          }

          if (group.name === 'Canoe VOD') {
            group.visible = process.env.ENABLE_CANOE_VOD
          }
        })
        if (model === null) {
          this.groups.forEach(group => {
            group.checked = true
          })
          this.model = {}
        } else if (model === undefined) {
          return
        } else {
          /**
           * model.values
           * group.value
           *
           * group can contain multiple values from model
           * for group in groups
           *  for value in values in group
           *    for m in model.values
           *      if value in values in geoup --- m
           *        selected
           *        break
           */
          const mvalues = model.values
          // only set the groups if all the values in the group are contained in mvalues
          this.groups.forEach(group => {
            // the models values are the same values given to the groups
            const gvalues = group.value
            if (Array.isArray(gvalues)) {
              // use an arry, all values in the array need to be true for the group to be selected
              const selected = []
              for (let gi = 0; gi < gvalues.length; gi++) {
                const currentGValue = gvalues[gi]
                let passed = false
                for (let mi = 0; mi < mvalues.length; mi++) {
                  const currentMValue = mvalues[mi]
                  if (currentGValue === currentMValue) {
                    passed = true
                    break
                  }
                }
                selected.push(passed)
              }
              const selectedGroupValue = selected.reduce((prev, curr) => prev && curr, true)
              group.checked = selectedGroupValue
            } else {
              // the value is just a string
              let passed = false
              for (let mi = 0; mi < mvalues.length; mi++) {
                const currentMValue = mvalues[mi]
                if (gvalues === currentMValue) {
                  passed = true
                  break
                }
              }
              group.checked = passed
            }
          })
          this.model = model
        }
        this.updateSelectAllState()
      },
    },
    computed: {
      visibleGroups() {
        return this.groups.filter(group => group.visible)
      },
      activeGroups() {
        return this.groups.filter(group => group.checked)
      },
    },
  })
</script>

<style>
  .search-set-filter-checkbox {
    align-items: center;
    height: 100%;
    line-height: normal;
    font-size: 14px;
  }
  .isChecked {
    pointer-events: none;
  }
</style>



// WEBPACK FOOTER //
// SearchSetFilter.vue?009b972a